/*eslint react/no-deprecated: 0*/
import React from 'react';
import moment from 'moment';
import FontAwesome from 'react-fontawesome';
import * as MaterialUI from 'material-ui';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Row, Col, Container } from 'reactstrap';

import ItemListC from './itemList';
import * as viajesActions from 'modules/viajes/action';
import * as trayectosActions from 'modules/trayectos/action';
import * as generalActions from 'modules/general/action';
import * as registrosActions from 'modules/registros/action';
import { traducirAccion, checkPermissions, pickAColor } from 'core/generalFunctions';

moment.locale('es');

import areIntlLocalesSupported from 'intl-locales-supported';

let DateTimeFormat;
if (areIntlLocalesSupported(['es', 'es-AR'])) {
  DateTimeFormat = global.Intl.DateTimeFormat;
} else {
  const IntlPolyfill = require('intl');
  DateTimeFormat = IntlPolyfill.DateTimeFormat;
  require('intl/locale-data/jsonp/es');
  require('intl/locale-data/jsonp/es-AR');
}

@connect((store) => ({
  trayectos: store.getIn(['trayectos', 'lista']),
  nombreUser: store.getIn(['user', 'nombre']),
  apellidoUser: store.getIn(['user', 'apellido']),
  viajesHoy: store.getIn(['viajes', 'hoy']),
  viajesManana: store.getIn(['viajes', 'manana']),
  userRoles: store.getIn(['user', 'roles']),
  logs: store.getIn(['registros', 'logs']),
}))
export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount = () => {
    this.changeTitle(this.props.params.statusView);
    checkPermissions(['admin', 'administrador_viajes', 'ver_viajes', 'administrador_reservas']) && this.props.dispatch(viajesActions.get());
    if (checkPermissions(['admin', 'ver_alertas_empleados'])) {
      this.props.dispatch(registrosActions.get());
      this.props.dispatch(registrosActions.getLogs(moment()));
    }
    this.props.dispatch(trayectosActions.get());
  };
  componentWillReceiveProps = (newProps) => {
    this.props.params.statusView != newProps.params.statusView && this.changeTitle(newProps.params.statusView);
    if (newProps.userRoles && !this.props.userRoles.equals(newProps.userRoles) && checkPermissions(['admin', 'administrador_viajes', 'ver_viajes', 'administrador_reservas'])) {
      this.props.dispatch(viajesActions.get());
      if (checkPermissions(['admin', 'ver_alertas_empleados'])) {
        this.props.dispatch(registrosActions.get());
        this.props.dispatch(registrosActions.getLogs(moment()));
      }
    }
  };
  changeTitle = (statusView) => {
    if (statusView == 'buscado') this.props.dispatch(generalActions.dashboard_changeTitle('BUSCAR VIAJES'));
    else this.props.dispatch(generalActions.dashboard_changeTitle('RESERVAS'));
  };
  buscarViaje(e, diaBuscando) {
    this.props.dispatch(viajesActions.setState({ statusView: 'buscado', diaBuscando }));
    this.props.dispatch(viajesActions.buscar(diaBuscando));
  }
  componentWillUnmount = () => this.props.dispatch(registrosActions.clear('logs'));
  render() {
    const { viajesHoy, viajesManana, logs, apellidoUser, nombreUser, trayectos, dispatch } = this.props;
    return (
      <div>
        <Row className="rowContainer">
          <Col md="8" className="alignStart">
            <MaterialUI.Paper zDepth={1}>
              <MaterialUI.Tabs>
                <MaterialUI.Tab label="HOY" className="bg-2">
                  <ListaReservas trayectos={trayectos} viajes={viajesHoy} />
                </MaterialUI.Tab>
                <MaterialUI.Tab label={`MAÑANA ${moment().add(1, 'day').format('DD/MM')}`} className="bg-2">
                  <ListaReservas trayectos={trayectos} viajes={viajesManana} />
                </MaterialUI.Tab>
              </MaterialUI.Tabs>
            </MaterialUI.Paper>
            <div className="pt-30">
              <p>
                <FontAwesome name="warning" className="iconAlert iconInfo" /> Alerta: viaje sin localización
              </p>
              <p>
                <FontAwesome name="users" className="iconInfo" /> Viaje privado
              </p>
              <p>
                <FontAwesome name="calendar" className="iconInfo" /> Viaje creado por rutina
              </p>
              <p>
                <FontAwesome name="map-marker" className="red iconAlert" /> Ultima localización hace más de 15 minutos
              </p>
              <p>
                <FontAwesome name="map-marker" className="yellow iconAlert" /> Ultima localización hace más de 5 minutos
              </p>
              <p>
                <FontAwesome name="map-marker" className="green iconAlert" /> Ultima localización hace menos de 5 minutos
              </p>
            </div>
          </Col>
          <Col md="4" className="alignStart">
            <MaterialUI.AppBar
              title="HISTORIAL"
              iconElementLeft={<div />}
              iconElementRight={
                <div className="p-7">
                  <p className="white">{nombreUser}</p>
                  <p className="white">{apellidoUser}</p>
                </div>
              }
              className="bg-3"
            />
            <MaterialUI.Paper zDepth={2} className="container">
              <MaterialUI.List className="noPadding scroll1000">
                {logs.map((log, i) => {
                  const accionTraducida = traducirAccion(log.get('accion'));
                  return (
                    <div key={i}>
                      <MaterialUI.ListItem
                        className="font13"
                        nestedListStyle={{ padding: '0' }}
                        autoGenerateNestedIndicator={false}
                        innerDivStyle={{ padding: 7 }}
                        onClick={() => this.setState({ [log.get('id')]: !this.state[log.get('id')] })}
                        open={this.state[log.get('id')]}
                        secondaryText={log.getIn(['_usuario', 'nombre']) && log.getIn(['_usuario', 'nombre']) + ' ' + log.getIn(['_usuario', 'apellido'])}
                        primaryText={accionTraducida.accion}
                        rightIconButton={
                          <div>
                            <FontAwesome name={accionTraducida.icon} style={{ paddingRight: '10px', fontSize: '20px', color: accionTraducida.color }} />
                            {moment(log.get('fecha')).format('HH:mm')}
                          </div>
                        }
                        nestedItems={reqData(log, { viajesHoy, viajesManana }, dispatch)}
                      />
                      <MaterialUI.Divider />
                    </div>
                  );
                })}
              </MaterialUI.List>
            </MaterialUI.Paper>
          </Col>
        </Row>
      </div>
    );
  }
}

const reqData = (log, { viajesHoy, viajesManana }, dispatch) => {
  if (log.get('accion') != 'reserva_creada_cliente' || !log.get('req')) return [];
  const viaje = viajesHoy.find((v) => v.get('id') == log.getIn(['req', 'viajeId'])) || viajesManana.find((v) => v.get('id') == log.getIn(['req', 'viajeId']));
  if (viaje)
    return [
      <MaterialUI.ListItem
        key={0}
        className="noPadding font13"
        primaryText={
          <Row>
            <Col md="1">
              <FontAwesome name="bus" />
            </Col>
            <Col md="6">{`${viaje.getIn(['_trayecto', 'nombre'])} ${viaje.getIn(['_trayecto', 'subnombre']) || ''}`}</Col>
            <Col md="2">{moment(viaje.get('horario')).isSame(moment(), 'day') ? 'Hoy' : moment(viaje.get('horario')).format('DD/MM')}</Col>
            <Col md="2">{moment(viaje.get('horario')).format('HH:mm')}hs</Col>
          </Row>
        }
        onClick={() => dispatch(push('/dashboard/reservas/pasajeros/' + viaje.get('id')))}
      />,
    ];
  else return [];
};

class ListaReservas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      trayectoFilter: false,
      horarioFilter: false,
    };
  }

  render() {
    const { trayectoFilter, horarioFilter } = this.state;
    const { trayectos = [], viajes = [] } = this.props;

    return (
      <MaterialUI.List className="noPadding">
        <Container>
          <Row>
            <MaterialUI.RaisedButton onClick={() => this.setState({ trayectoFilter: false, horarioFilter: false })} primary={true} label="Ver Todos" className="fullWidthComponent noPadding" />
          </Row>
          <Row>
            <Col md="8">
              <MaterialUI.SelectField autoWidth={true} fullWidth={true} floatingLabelText="Trayecto" value={trayectoFilter} onChange={(e, i, trayectoFilter) => this.setState({ trayectoFilter })}>
                <MaterialUI.MenuItem value={false} primaryText="Todos" />
                {trayectos &&
                  trayectos
                    .groupBy((t) => t.get('nombre'))
                    .map((t) => {
                      t = t.first();
                      if (!t.get('id')) return;
                      return (
                        <MaterialUI.MenuItem
                          key={t.get('id')}
                          value={t.get('nombre')}
                          primaryText={t.get('subnombre') ? t.get('nombre') + ' - ' + t.get('subnombre') : t.get('nombre')}
                          style={{ color: pickAColor(t.get('id')) }}
                        />
                      );
                    })}
              </MaterialUI.SelectField>
            </Col>
            <Col md="4">
              <MaterialUI.SelectField autoWidth={true} fullWidth={true} floatingLabelText="Rutinas" value={horarioFilter} onChange={(e, i, horarioFilter) => this.setState({ horarioFilter })}>
                <MaterialUI.MenuItem value={false} primaryText="Todos" />
                {viajes.map((v) => (
                  <MaterialUI.MenuItem key={v.get('id')} value={v.get('horario')} primaryText={moment(v.get('horario')).format('HH:mm')} />
                ))}
              </MaterialUI.SelectField>
            </Col>
          </Row>
        </Container>
        {viajes.size > 0 &&
          viajes
            .filter((p) => (trayectoFilter ? p.getIn(['_trayecto', 'nombre']) == trayectoFilter : true))
            .filter((p) => (horarioFilter ? moment(p.get('horario')).isSameOrAfter(moment(horarioFilter)) : true))
            .map((viaje) => <ItemListC key={viaje.get('id')} viaje={viaje} manana />)}
      </MaterialUI.List>
    );
  }
}



// WEBPACK FOOTER //
// src/modules/viajes/components/main.js